import React from 'react';
import { Sparkles } from 'lucide-react';

export default function VidyaJyotiBanner() {
  return (
    <div className="vj-motto-ribbon my-4">
      <p className="vj-motto-text">
        "Vidyajyoti is more than just an academic institution. It is a way of life designed to form men and women dedicated to the service of others, who let the inner Divine Light shine out through them."
      </p>
      <span className="vj-motto-caption">
        <Sparkles size={14} className="me-1 inline-block" />
        Vidyajyoti College of Theology • Delhi
      </span>
    </div>
  );
}
